import classNames from "classnames";
import PAImage from "component/design-system/images/PAImage";
import PAText from "component/design-system/typography/PAText/PAText";
import withShoppingCartState from "hoc/withShoppingCartState";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { FREE_DELIVERY_PRICE } from "../../../constant/shared-constants";
import styles from "./productBadge.module.scss";

function ProductBadge(props: any) {
  const { product, showIcon = true, isGridView = false } = props;
  const { t } = useTranslation("category");

  const productDeliveryMethodDetails = useSelector((state: RootState) => state.apiReducer.productDeliveryMethodDetails[product.sku]);
  const { shippingAvailable, deliveryAvailable, pickUpAvailable } = productDeliveryMethodDetails || {};

  const methods = {
    shipping: {
      text: product.price <= FREE_DELIVERY_PRICE ? "Qualify for Free Shipping" : "Free Shipping",
      show: shippingAvailable,
    },
    pickup: {
      text: (!shippingAvailable && !deliveryAvailable && pickUpAvailable) ? "In-store Pickup Only" : "Store Pickup",
      show: pickUpAvailable,
    },
    delivery: {
      text: "Rapid Delivery",
      show: deliveryAvailable,
    },
  };

  return (
    <div className={classNames(styles.badge_container, { [styles.badge_container_grid]: isGridView })}>
      {Object.keys(methods).map((method) => {
        const { text, show } = methods[method];
        return (
          <HideIf key={text} show={show}>
            <div className={classNames(styles.badge, { [styles.badge_shipping]: method === "shipping" })}>
              <HideIf show={showIcon}>
                <PAImage
                  src={getRelativeImagePath(`/cms/pubicImages/images/badge-${method}.png`)}
                  alt={method}
                  width={20}
                  height={20}
                  className={styles.icon}
                />
              </HideIf>
              <PAText className={`${styles.bold_text}`} data-content={t(text)}>
                {t(text)}
              </PAText>
              <span className={styles.separator} />
            </div>
          </HideIf>
        );
      })}
    </div>
  );
}

export default withShoppingCartState(ProductBadge);
